import type { ThemeMode } from '../theme/theme.types'
import { useTheme } from '../theme/ThemeContext'

function IconSun({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
      />
    </svg>
  )
}

function IconMoon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
      />
    </svg>
  )
}

function IconSystem({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"
      />
    </svg>
  )
}

const options: {
  value: ThemeMode
  label: string
  Icon: typeof IconSun
}[] = [
  { value: 'light', label: 'Φωτεινό θέμα', Icon: IconSun },
  { value: 'dark', label: 'Σκοτεινό θέμα', Icon: IconMoon },
  { value: 'system', label: 'Όπως το σύστημα', Icon: IconSystem },
]

export function ThemeSwitcher() {
  const { mode, setMode } = useTheme()

  return (
    <div
      className="inline-flex shrink-0 gap-0.5 rounded-2xl border border-zinc-200/90 bg-zinc-100/80 p-0.5 dark:border-zinc-700 dark:bg-zinc-800/80"
      role="group"
      aria-label="Επιλογή θέματος"
    >
      {options.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          onClick={() => setMode(value)}
          aria-label={label}
          title={label}
          className={`flex h-9 w-9 items-center justify-center rounded-xl transition sm:h-10 sm:w-10 ${
            mode === value
              ? 'bg-white text-violet-700 shadow-sm dark:bg-zinc-900 dark:text-violet-300'
              : 'text-zinc-600 hover:bg-zinc-200/80 hover:text-zinc-900 dark:text-zinc-400 dark:hover:bg-zinc-700/80 dark:hover:text-zinc-100'
          }`}
        >
          <Icon className="h-5 w-5" />
        </button>
      ))}
    </div>
  )
}
